export default function() {
  this.rows = [];
  this.elementsCount = 0;
  this.stState = {};
  this.acutalFilters = {};
  this.downloadComplete = false;
  this.loadRowsState = false;
  this.lastPage = 0;
  this.setRows = response => {
    this.rows = response.data;
    this.elementsCount = response.total;
  };

  return {
    // params for function with Paging should be given without SortingPager. It will be set in the function
    setUpPipe: (getFunction, params) => {
      return tableState => {
        this.stState = tableState;
        let pagination = tableState.pagination;
        let sorting = tableState.sort;
        let number = pagination.number || 10;

        let start = 1;
        if (pagination.start) {
          start = Math.ceil(pagination.start / number) + 1;
        }
        params.limit = number;
        params.page = start;
        params.orderColumn = sorting.predicate;
        params.direction = sorting.reverse == null || sorting.reverse ? 'DESC' : 'ASC';
        this.acutalFilters = params;
        return getFunction(params, response => {
          this.setRows(response);
          tableState.pagination.numberOfPages = Math.ceil(response.total / number);
          this.downloadComplete = true;
          return this.rows;
        }).$promise;
      };
    },
    setUpPipePost: (postFunction, params, pageStart = 0) => {
      return tableState => {
        this.loadRowsState = true;
        this.stState = tableState;
        let pagination = tableState.pagination;
        let sorting = tableState.sort;
        let number = pagination.number || 10;

        if (!params.filter) {
          params.filter = {};
        }

        if (pageStart && !this.downloadComplete) {
          tableState.pagination.start = pageStart;
        }

        params.pagination = {};
        params.pagination.limit = number;
        params.pagination.offset = pagination.start;
        params.pagination.order = sorting.reverse == null || sorting.reverse ? 'DESC' : 'ASC';

        params.pagination.sortBy = {};
        params.pagination.sortBy.name = sorting.predicate;
        this.acutalFilters = params;
        return postFunction({}, params, response => {
          this.setRows(response);
          tableState.pagination.numberOfPages = Math.ceil(response.total / number);
          this.lastPage = pagination.start;
          this.downloadComplete = true;
          this.loadRowsState = false;
          return (this.rows = response.data);
        }).$promise;
      };
    },
    getRows: () => {
      return this.rows;
    },
    getLoadRowsState: () => {
      return this.loadRowsState;
    },
    getElementsCount: () => {
      return this.elementsCount;
    },
    resetPageNumber: () => {
      this.stState.pagination.start = 0;
    },
    getLastPage: () => {
      return this.lastPage;
    },

    getTableState: () => {
      return this.stState;
    },
    getActualFilters: () => {
      return this.acutalFilters;
    },
    isDownloadComplete: () => {
      return this.downloadComplete;
    },
    cleanUp: () => {
      this.rows = [];
      this.elementsCount = 0;
      this.stState = {};
      this.acutalFilters = {};
      this.downloadComplete = false;
    }
  };
}
